import { Paper, Table, TableContainer } from '@mui/material'
import { EmployeeHolidayBalance } from '@/types'
import { HrInternalHoursTableHead } from './HrInternalHoursTableHead'
import { HrInternalHoursTableBody } from './HrInternalHoursTableBody'

export type HrInternalHoursTableProps = {
  rows: EmployeeHolidayBalance[]
}

export const HrInternalHoursTable = ({
  rows,
}: HrInternalHoursTableProps): JSX.Element => (
  <TableContainer component={Paper}>
    <Table stickyHeader={true}>
      <HrInternalHoursTableHead />
      <HrInternalHoursTableBody rows={rows} />
    </Table>
  </TableContainer>
)
